// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1pkjv","errors":"Errors_errors__1bM5J"};